// src/app/models/piece.ts
export class Piece {
    name: string
    status: string
    projetName: string
    category: string
    type: string
    nbPieces: number
    nbPiscine: number
    adresse: string
    description: string
    prixMdt: string
    surface: string
    photos: string[]
    Description: any
    
    // Ajouter ces propriétés
    nbChambres?: number
    nbSallesDeBain?: number
    pieceId?: number
    projetId?: number
    createdAt?: string
    updatedAt?: string
      videoUrl?: string | null;
}